import React from 'react';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { ErrorPageWrapper, ErrorWidget } from '@zep/web-components';
export const NotFoundPlanPageView = () => {
  return <ErrorPageWrapper data-sentry-element="ErrorPageWrapper" data-sentry-component="NotFoundPlanPageView" data-sentry-source-file="plan.tsx">
      <ErrorNotFoundPlanWidget data-sentry-element="ErrorNotFoundPlanWidget" data-sentry-source-file="plan.tsx" />
    </ErrorPageWrapper>;
};
const ErrorNotFoundPlanWidget = () => {
  const {
    t,
    ready
  } = useTranslation(['subscription']);
  const imageUrl = '/images/error_500.png';
  const title = t('subscription:notFountPlan.title.text');
  const description = t('subscription:notFountPlan.description.text');
  if (!ready) return null;
  return <ErrorWidget.Root data-sentry-element="unknown" data-sentry-component="ErrorNotFoundPlanWidget" data-sentry-source-file="plan.tsx">
      <ErrorWidget.Header data-sentry-element="unknown" data-sentry-source-file="plan.tsx">
        <ErrorWidget.Image src={imageUrl} data-sentry-element="unknown" data-sentry-source-file="plan.tsx" />
      </ErrorWidget.Header>
      <ErrorWidget.Content data-sentry-element="unknown" data-sentry-source-file="plan.tsx">
        <ErrorWidget.Title data-sentry-element="unknown" data-sentry-source-file="plan.tsx">{title}</ErrorWidget.Title>
        <ErrorWidget.Description data-sentry-element="unknown" data-sentry-source-file="plan.tsx">{description}</ErrorWidget.Description>
      </ErrorWidget.Content>
      <ErrorWidget.Footer data-sentry-element="unknown" data-sentry-source-file="plan.tsx">
        <Button key={1} size={'lg'} as="a" href={'/'} data-sentry-element="Button" data-sentry-source-file="plan.tsx">
          {t('subscription:notFountPlan.button.text')}
        </Button>
      </ErrorWidget.Footer>
    </ErrorWidget.Root>;
};